export default "__VITE_ASSET__VvO2ZCvq__"